export const CONTACT_US = 'CONTACT_US'

export const ERROR_STATE = 'ERROR_STATE'
